/* eslint-disable */

const internalTags = [
  'marketing-analytics-suite',
  'sales-analytics-suite',
  'service-analytics-suite',
  'commerce-analytics-suite',
];
const internalTagsQueryStr = internalTags
  .map((tag) => `internalTags=${tag}`)
  .join('&');

const REPORT_TEMPLATES_URL = `/reporting-discovery/v1/report-template?${internalTagsQueryStr}&hydrate=&`;

const MAX_TIMEOUT = 50000;

const BASE_CONFIG = {
  timeout: MAX_TIMEOUT,
  dataType: 'json',
  contentType: 'application/json',
  type: 'GET',
};

const REPORTS_PARAMS = (portal_id) => ({
  portalId: portal_id,
  sortOrder: 'descending',
  offset: 0,
  sortBy: 'updated_at',
  limit: 15,
  source: 'REPORTING',
});

function serializeQuery(key, value) {
  return `${key}=${value}`;
}

const REPORTS_QUERY = (portal_id) => {
  return Object.entries(REPORTS_PARAMS(portal_id))
    .map(([key, value]) => {
      if (Array.isArray(value)) {
        return value
          .map((v) => {
            return serializeQuery(key, v);
          })
          .join('&');
      } else {
        return serializeQuery(key, value);
      }
    })
    .join('&');
};

(function () {
  window.quickFetch.makeEarlyRequest('dashboards', {
    url: window.quickFetch.getApiUrl(
      '/dashboard/v2/dashboard?hydrate=USER_PERMISSION_LEVEL'
    ),
    ...BASE_CONFIG,
  });

  window.quickFetch.afterAuth((auth) => {
    window.quickFetch.makeEarlyRequest('reports', {
      url: window.quickFetch.getApiUrl(
        `/dashboard/v2/reports?${REPORTS_QUERY(auth.portal.portal_id)}`
      ),
      ...BASE_CONFIG,
    });
  });

  const isTemplateUrl = window.location.pathname.includes('/templates/');
  if (isTemplateUrl) {
    window.quickFetch.makeEarlyRequest('reportTemplates', {
      url: window.quickFetch.getApiUrl(REPORT_TEMPLATES_URL),
      timeout: 15000,
      dataType: 'json',
      contentType: 'application/json',
      type: 'GET',
    });
  }
})();
